import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { QuickLinkOperationStore } from './QuickLinkOperationStore'
import { QuickLinkListStore } from './QuickLinkListStore'

export class QuickLinksStore {
  private readonly _operationStore: QuickLinkOperationStore
  private _listStore = new QuickLinkListStore()

  constructor(private _entities: IEntitiesStore) {
    this._operationStore = new QuickLinkOperationStore(this._entities)

    makeAutoObservable(this)
  }

  get operationStore() {
    return this._operationStore
  }

  get listStore() {
    return this._listStore
  }

  init = () =>
    Promise.all([
      this._entities.integrationsStore.fetchIntegrations(),
      this._entities.mergeFieldStore.loadAllFields(),
      this.listStore.init(),
    ])

  dispose = () => {
    this._operationStore.dispose()
    this._listStore.dispose()
  }
}
